<template>
  <div class="result-item d-flex align-center py-1">
    <v-icon
      :aria-label="result.passes ? $bct('Passing rule') : $bct('Failed rule')"
      :class="result.passes ? 'text-success' : 'text-error'"
      :icon="result.passes ? 'check' : 'close'"
      :size="size"
      class="mr-2"
    />
    <span class="result-message">{{ $bct(result.message) }}</span>
  </div>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  result: {
    type: Object,
    required: true,
  },
  size: {
    type: String,
    default: 'small',
  },
});
</script>

<style scoped>
.result-item {
  gap: 8px;
}

.result-message {
  flex: 1;
  font-size: 15px;
  line-height: 1.5;
}
</style>
